import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Stack } from '@mui/material';

import { Icon, Mask, Pill, Company } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { getPillColor } from '@flows/private/financial/helpers/getPillColor';
import { BillDetailRouter } from '@flows/private/financial/pages/Detail/router';

import { ActionButton, Line, StyledGrid } from './styles';
import type { BillRowPropsMobile } from './types';

// TO-DO: funcionalidade alterada a pedido da área de negócios, prop onDownloadBill será necessária caso a funcionalidade seja reativada
export function BillRowMobile({ bill }: Readonly<BillRowPropsMobile>) {
  const navigate = useNavigate();

  const { number, status, healthOperator, amount, billType } = bill;

  const labelValuePairs = [
    { label: 'Fatura', value: number },
    { label: 'Tipo', value: billType },
    { label: 'Valor', value: Mask.currency(amount) },
  ];

  return (
    <Line container alignItems="center">
      <Stack
        flexDirection="row"
        alignItems="flex-start"
        mb={1.5}
        width="100%"
        justifyContent="space-between"
      >
        <Stack alignItems="flex-start" justifyContent="flex-start">
          <Stack height="30px">
            <Company company={healthOperator} />
          </Stack>
          <Stack gap={0.5} mt={1.5}>
            {labelValuePairs.map(item => (
              <Typography variant="body2" key={item.label}>
                {item.label}
              </Typography>
            ))}
          </Stack>
        </Stack>
        <Stack alignItems="flex-end" justifyContent="space-between">
          <Stack height="30px">
            <Pill color={getPillColor(status)} text={status} fitContent />
          </Stack>
          <Stack gap={0.5} alignItems="flex-end" mt={1.5}>
            {labelValuePairs.map(item => (
              <Typography variant="body2" key={item.value}>
                {item.value}
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Stack>
      <StyledGrid item xs={12}>
        <Grid container spacing={1.5} justifyContent="space-between">
          {/*
          <Grid item xs={6}>
             TO-DO: funcionalidade ocultada a pedido da área de negócios
            <ActionButton
              onClick={() => onDownloadBill(bill.billingNumber)}
              variant="outlined"
              fullWidth
              size="small"
              color="secondary"
              endIcon={
                <Icon
                  name="download"
                  color={COLORS.PRIMARY.BLUE['+1']}
                  size={20}
                />
              }
            >
              Baixar
            </ActionButton>
          </Grid>
          */}
          <Grid item xs={12}>
            <ActionButton
              onClick={() => {
                navigate(
                  BillDetailRouter.dynamicPath({
                    billNumber: bill.number,
                  }),
                );
              }}
              color="secondary"
              variant="contained"
              size="small"
              fullWidth
              endIcon={
                <Icon
                  color={NEW_COLORS.BASE.WHITE}
                  name="actions-b2b-chevron-right"
                  size={20}
                />
              }
            >
              Ver mais
            </ActionButton>
          </Grid>
        </Grid>
      </StyledGrid>
    </Line>
  );
}
